import { connect } from 'react-redux'
import MicrophoneSelector from './MicrophoneSelector'
import { State } from '../../dataStore/reducers/reducerType'
import { MicrophoneSelectorProps } from './types'

const mapStateToProps = (state: State, props: Omit<MicrophoneSelectorProps, 'options'>): MicrophoneSelectorProps => ({
  selectedMicrophone: props.selectedMicrophone,
  onMicrophoneChange: props.onMicrophoneChange,
  label: props.label,
  switchComponent: props.switchComponent,
  isDialInConnected: props.isDialInConnected,
  options: state.config.inputDevices
})

export default connect(mapStateToProps)(MicrophoneSelector)
